import { jsx as _jsx } from "react/jsx-runtime";
import styled, { keyframes } from 'styled-components';
export default function CircleLoader({ size = '1rem', className = '' }) {
    return (_jsx(Container, { size: size, className: `${className} ui-circle-loader` }));
}
const animation = keyframes `
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;
const Container = styled.div `
  display: inline-block;
  position: relative;
  width: ${p => p.size};
  height: ${p => p.size};

  border-radius: 50%;
  background-color: transparent;
  border: 0.125rem solid var(--text-third);
  border-top: 0.125rem solid var(--text-primary);
  border-bottom: 0.125rem solid var(--text-primary);
  animation: 1s ${animation} linear infinite;
`;
